import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function ReinforceWithPrayer() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Reinforce the defenses with unceasing prayer" />
        <blockquote>
          “And do not lead us into temptation, but deliver us from evil” (Matthew 6:13)
        </blockquote>

        <p>Jesus taught His disciples to pray for deliverance from evil and for God to lead them away from temptation. He also commands us to pray at all times and not to lose heart (Luke 18:1). This is the next Rebuild step we need to do daily in our struggle to overcome sin in our lives. Every day we need to ask God to help us avoid sin, to keep us from stumbling. Make this a regular habit, to ask God for help in the morning, for wisdom, for a commitment to doing what is right, for an avoidance of that which causes loss, destruction, pain, guilt, and death – to not even be tempted by those things. Ask God at the start of each day for a day of joy and peace, freedom from sin, and walking in the Spirit. God will honor this request and put a hedge around us, one more line of defense against temptation. If we are praying for deliverance each day, we still may be tempted, but it will not take us by surprise; we will see it sooner and have more opportunity to avoid it. Victory will already be on our mind, and with God helping us, we will have the advantage on the battlefield. We will have more strength and power to respond appropriately to temptation and resist it when it comes.</p>
        <br />

        <ul>
          <li>
            <strong>Ask daily for protection and deliverance from temptation.</strong><br />
            <em>Psalms 17:6-9, 32:6-8, 119:10, 133, 145-147; 141:8-10, Matthew 6:13, 26:41</em>
          </li>
          <br />
          <li>
            <strong>Ask God to keep you from sinning in word or deed.</strong><br />
            <em>Psalm 141:3-4</em>
          </li>
          <br />
          <li>
            <strong>Ask for understanding of your sins and blind spots.</strong><br />
            <em>Psalm 19:12-13, 139:23-24</em>
          </li>
          <br />
          <li>
            <strong>Ask for complete victory over temptation. Ask God for diligence in keeping His Word and staying on course. Ask God to give you victory over fleshly lusts, which wage war against the soul.</strong><br />
            <em>Psalm 119:4, 29, 36-37, 58, Matthew 7:7-11, 1 Corinthians 10:13, 1 Peter 2:11, 2 Peter 1:3-11</em>
          </li>
          <br />
          <li>
            <strong>Ask for protection for others.</strong><br />
            <em>Ephesians 6:18, Colossians 4:2, 1 Peter 5:8-9</em>
          </li>
          <br />
          <li>
            <strong>Think, pray, and seek godly counsel before taking action.</strong><br />
            <em>Proverbs 19:2, 21:5</em>
          </li>
          <br />
          <li>
            <strong>Pray according to the will of God.</strong><br />
            <em>Matthew 6:10, 26:39-42, 1 John 5:14-15</em>
          </li>
          <br />
          <li>
            <strong>Pray with expectant faith. Believe that God will do it.</strong><br />
            <em>Psalm 37:5, Proverbs 3:5-6, Matthew 17:20, 18:19, 21:21-22, Mark 11:22-24, Philippians 4:6-7, James 1:5-8, 5:15</em>
          </li>
          <br />
          <li>
            <strong>Pray in the Name of Christ.</strong><br />
            <em>John 14:13-16, 16:23-24</em>
          </li>
          <br />
          <li>
            <strong>Pray persistently; make prayer to God an unceasing habit.</strong><br />
            <em>Luke 18:1-8, 11:5-10, Ephesians 6:18, 1 Thessalonians 5:17</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
